export default {"src":"/_next/static/media/ic_logo_circle.042581ad.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};